export default "__VITE_ASSET__h6J$1PCu__"